import { Empty, Modal, Spin } from "antd"
import { useEffect, useState } from "react"
import { Attachment } from "../attachments/attachmentsModel"
import { useCustomerPhotosQuery } from "./customerQueries"
import "./CustomerPhotoGalleryModal.css"

type Props = {
  open: boolean
  customerId: number
  currentPrimaryPhotoId?: string | null
  onSelect: (attachment: Attachment) => void
  onClose: () => void
}

const CustomerPhotoGalleryModal = ({ open, customerId, currentPrimaryPhotoId, onSelect, onClose }: Props) => {
  const photosQuery = useCustomerPhotosQuery(customerId, open)
  const photos = photosQuery.data ?? []
  const [selectedId, setSelectedId] = useState<string | null>(null)

  useEffect(() => {
    if (open) {
      setSelectedId(currentPrimaryPhotoId ?? null)
    }
  }, [open, currentPrimaryPhotoId])

  const selected = photos.find(p => p.id === selectedId)

  return <Modal
    open={open}
    title="Select Primary Photo"
    width={720}
    okText="Select"
    okButtonProps={{ disabled: !selected }}
    onOk={() => {
      if (selected) {
        onSelect(selected)
        onClose()
      }
    }}
    onCancel={onClose}
  >
    {photosQuery.isLoading
      ? <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
      : photos.length === 0
        ? <Empty description="There are no image attachments for this customer" />
        : <div className="customer-photo-gallery">
            {photos.map(photo => <button
              key={photo.id}
              type="button"
              className={`customer-photo-gallery__item${photo.id === selectedId ? ' customer-photo-gallery__item--selected' : ''}`}
              onClick={() => setSelectedId(photo.id)}
            >
              <img src={photo.thumbnail ?? photo.url} alt={photo.name} />
            </button>)}
          </div>}
  </Modal>
}

export default CustomerPhotoGalleryModal
